import React from 'react';
import styled from 'styled-components';
import * as BuilderUI from '../../BuilderUI';
import {
  expandReroutingEventTooltip,
  foldReroutingEventTooltip,
  mergeReroutingEventTooltip,
} from '../../../KubitTooltip/globalTooltips';
import { theme } from '../../../../styles/theme';
import {
  SingleSelect,
  SingleSelectOption,
} from '../../../Dropdown/SingleSelect';

interface IProps {
  onAddExpand?: () => void;
  onAddFold?: () => void;
  onAddMerge?: () => void;
  disableExpand: boolean;
  disableFold: boolean;
  disableMerge: boolean;
}

const Label = styled(BuilderUI.LabelAction)`
  &:hover,
  [aria-expanded='true'] & {
    color: ${theme.colors.mainBlue};
    cursor: pointer;
  }
`;

const ReroutingEventsMenu = ({
  onAddExpand,
  onAddFold,
  onAddMerge,
  disableExpand,
  disableFold,
  disableMerge,
}: IProps) => {
  return (
    <SingleSelect
      trigger={<Label>+ Add Adjustment</Label>}
      placement="bottom-start"
    >
      {onAddExpand && (
        <SingleSelectOption
          iconName="expand-event"
          label={'Expand Event'}
          onClick={onAddExpand}
          disabled={disableExpand}
          tooltipOption={expandReroutingEventTooltip}
        />
      )}
      {onAddMerge && (
        <SingleSelectOption
          iconName="merge-event"
          label={'Merge Event(s)'}
          onClick={onAddMerge}
          disabled={disableMerge}
          tooltipOption={mergeReroutingEventTooltip}
        />
      )}
      {onAddFold && (
        <SingleSelectOption
          iconName="fold-event"
          label={'Fold Event(s)'}
          onClick={onAddFold}
          disabled={disableFold}
          tooltipOption={foldReroutingEventTooltip}
        />
      )}
    </SingleSelect>
  );
};

export default ReroutingEventsMenu;
